module.exports = "https://cdn2-fs.clearscore.com/flux/images/3c7270e63a0c438891a8ff702e4ae71f.jpg";